import { BASE_URL_API } from '@constants/base';
import { get } from '@utils/ajax';

/**
 * Common Service
 * Handles common/shared API calls used across multiple screens
 */
const commonService = (() => {
    // Get delivery company list
    const getDeliveryCompanyList = async () => {
        try {
            const response = await get(
                `${BASE_URL_API}/common_api.php`,
                {
                    method: 'get_list_delivery_company'
                },
                {
                    showError: true
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    // Get pref list
    const getPrefList = async () => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { method: 'get_list_pref' },
            {
                showError: true
            }
        );
        return response;
    };

    // Get modal search
    const getDataModalSearch = async params => {
        try {
            const response = await get(`${BASE_URL_API}/common_api.php`, params, {
                showError: true
            });
            return response;
        } catch (error) {
            return error;
        }
    };

    // Get info company
    const getInfoCompany = async params => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { ...params, method: 'get_info_company' },
            {
                showError: true
            }
        );
        return response;
    };

    // Get list company
    const getListCompany = async () => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { method: 'get_list_company' },
            {
                showError: true
            }
        );
        return response;
    };

    const searchWarehouseList = async params => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { ...params, type_modal: 'warehouse_search', method: 'get_warehouse_list' },
            {
                showError: true
            }
        );
        return response;
    };

    const searchProductList = async params => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { ...params, type_modal: 'item_name_search', method: 'get_product_list' },
            {
                showError: true
            }
        );
        return response;
    };

    const searchPackStaffList = async params => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { ...params, type_modal: 'charge_staff_search', method: 'get_charge_staff_list' },
            {
                showError: true
            }
        );
        return response;
    };

    const searchSupportStaffList = async params => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { ...params, type_modal: 'support_staff_search', method: 'get_support_staff_list' },
            {
                showError: true
            }
        );
        return response;
    };

    const searchClientCompanyList = async params => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { ...params, type_modal: 'client_company_search', method: 'get_client_company_list' },
            {
                showError: true
            }
        );
        return response;
    };

    const searchClientStaffList = async params => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { ...params, type_modal: 'client_staff_search', method: 'get_client_staff_list' },
            {
                showError: true
            }
        );
        return response;
    };

    // Get unit options for inventory management
    const getUnitOptions = async () => {
        const response = await get(
            `${BASE_URL_API}/common_api.php`,
            { method: 'get_m_codes', shikibetu_cd: 'ITEMTYPE' },
            {
                showError: true
            }
        );
        return response;
    };

    // Get product detail by name or code
    // Priority: productCode > productName (if code exists, use code only; if not, use name)
    const getProductDetailByNameOrCode = async (productName, productCode) => {
        const params = { method: 'get_product_detail_by_name' };

        // If productCode exists, use only productCode; otherwise use productName
        if (productCode) {
            params.product_code = productCode;
        } else if (productName) {
            params.product_name = productName;
        }

        const response = await get(`${BASE_URL_API}/common_api.php`, params, {
            showError: true
        });
        return response;
    };

    return {
        getDeliveryCompanyList,
        getDataModalSearch,
        getPrefList,
        getInfoCompany,
        getListCompany,
        searchWarehouseList,
        searchProductList,
        searchPackStaffList,
        searchSupportStaffList,
        searchClientCompanyList,
        searchClientStaffList,
        getUnitOptions,
        getProductDetailByNameOrCode
    };
})();

export default commonService;
